<template>
  <div class="reserve">
    <img src="@/assets/images/answer.png" alt="" mode="widthFix" />
  </div>
</template>

<script>
export default {
  props: {},
}
</script>

<style lang="stylus" scoped>
  .reserve{
    height: 100%
    overflow hidden
    font-size 0
    img {
      width 100%
      height auto
    }
  }
</style>
